import clsx from "clsx";
import { LayoutGroup } from "framer-motion";
import { ComponentPropsWithoutRef, ReactElement, useId } from "react";

export const SidebarSection = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => {
  const id = useId();

  return (
    <LayoutGroup id={id}>
      <div
        {...props}
        className={clsx(className, "flex flex-col gap-0.5")}
        data-slot="section"
      />
    </LayoutGroup>
  );
};
